import { render, staticRenderFns } from "./RTLPage.vue?vue&type=template&id=fcdef1d0"
import script from "./RTLPage.vue?vue&type=script&lang=js"
export * from "./RTLPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports